exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".listing-meta{border-bottom:1px solid #e7e6e6}.featured-listing-wrap ul{padding:0;margin:0 auto 5px!important}.featured-listing-wrap h4{margin:0 auto 6px;font-size:18px}", ""]);

// exports
